@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/forms/select";

$self: ".a-dropdown";

:host {
  display: block;
}

.a-dropdown {
  &__select-wrapper {
    @include select.select-wrapper;

    &::after {
      @include select.arrow;
    }
  }

  &__select {
    @include select.select;
  }

  option {
    @include select.option;
  }

  &__label {
    @include select.label;
  }

  &--floating-label {
    #{$self}__label {
      @include select.floating-label__label;
    }

    #{$self}__select {
      @include select.floating-label__input;
    }
  }

  &--dynamic-width {
    display: inline-block;
  }

  &--disabled {
    &#{$self}--floating-label {
      #{$self}__label {
        color: select.$select-disabled-color;
      }
    }

    #{$self}__select {
      pointer-events: none;
    }

    #{$self}__select-wrapper {
      &::after {
        color: select.$select-disabled-color;
      }
    }
  }

  &--small {
    @include select.set-select-height(1.75rem);

    #{$self}__select {
      padding-left: bcp.size(6);
    }
  }
}

.acc-hide {
  @include bcp.acc-hide;
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
